import urlRegex from 'url-regex';

export const isValidUrl = (url: string): boolean => urlRegex({ exact: true }).test(url);
